<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <h2> <strong> {{elemento}}</strong> </h2>
        <p class="mb-0" v-if="parking"> Resumen del plan <strong>{{ parkingPlan }}</strong>  en el parking
          <strong>{{ parking.name }}</strong> </p>
      </CCol>
    </CRow>


    <CCard>
      <CCardBody borderColor="primary">
        <h5 class="subtitle mb-1">5. Resumen del plan prepago</h5>
        <p class="mb-3 text-primary">Pulsa siguiente para confirmar el pedido</p>

        <!-- <CForm @submit.prevent data-vv-scope="new-delivery"> -->

          <CRow>
            <CCol sm="12">

              <CCard body-wrapper>

                <!-- <div class="d-flex justify-content-between align-items-center mb-4">
                  <span>
                    <strong>Pedido: # {{ getPayment(productItem.payments) }}</strong>
                  </span>

                  <span v-if="!isActive(productItem.status)">
                    <a @click="downInvoice"
                    :class="{'text-primary': !isActive(productItem.status) }"
                    >Descargar Factura  <i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
                  </span>
                </div> -->

                <!-- <div class="d-flex justify-content-start align-items-end my-4">
                  <CIcon name="cil-calendar" height="56" class="text-secondary" />
                  <div class="ml-2">
                    <p class="mb-0">Fecha de inicio: {{ stringUtils.dateTimeFormat(productItem.entry_event.datetime) }}</p>
                    <p class="mb-0">Fecha de fin: {{ stringUtils.dateTimeFormat(productItem.exit_event.datetime) }}</p>
                  </div>
                </div> -->


                <div class="d-flex justify-content-start align-items-center my-4 info-my-rents">

                  <div class="mr-3">
                    <CIcon name="cil-calendar" height="56" class="text-secondary" />
                  </div>

                  <div>

                    <!-- <span class="mb-1">Producto: </span> -->

                      <p class="title-product mb-1">{{ productItem.plan.name }}</p>
                      <!-- <p class="mb-0">Desde {{ item.start_datetime | DateTimeDMYhms }} hasta {{ item.end_datetime | DateTimeDMYhms }} </p> -->

                      <p class="mb-0">Del {{ item.start_datetime | DateTimeDMYhms }} al {{ item.end_datetime | DateTimeDMYhms }}</p>
                      <!-- <p class="mb-0">Al {{ item.end_datetime | DateTimeDMYhms }}  </p> -->


                      <!-- <p class="mb-0">Del {{ item.start_datetime | DateDMY }} a las {{ item.start_datetime | Timeh:m:s }} </p>
                      <p class="mb-0">Al {{ item.end_datetime | DateDMY }} a las  {{ item.end_datetime | Timeh:m:s }}  </p> -->
                    <!-- </span> -->
                  </div>





                </div>


                <div class="d-flex justify-content-between align-items-center my-4 info-my-rents">

                  <div>
                    <strong>{{ productItem.parking.name }}</strong>
                    <p>{{ productItem.parking.address }}</p>
                  </div>



                  <div class="text-right">
                    <span>Total: </span>
                    <strong> {{ productItem.amount }} € </strong>
                    <p class="mt-0 text-black-50"> (IVA incluido)</p>
                  </div>
                </div>



                <div class="d-flex justify-content-between align-items-center">

                  <!-- <CButton @click="gotToDetail"  color="outline-dark" shape="pill" class="px-4">Detalle</CButton> -->


                    <!-- <CSwitch class="mx-1"
                      color="primary"
                      variant="3d"
                      shape="square"
                      :checked="productItem.renewal ? productItem.renewal : false"
                      v-bind="labelIcon"
                      :value="productItem"
                      :disabled="productItem.status == 'FINISHED'"

                      @update:checked="() => $emit('toggle-renewal', productItem)"
                    /> -->


                  <!-- <span :class="`text-${getStatusColor(productItem.status)}`">
                    {{stringUtils.getLabelStatus(productItem.status)}}</span> -->

                </div>

                </CCard>


            </CCol>

          </CRow>


        <!-- </CForm> -->

        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>

       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>

    <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="saveDelivery" class="btn-login-new-delivery btn" >
        <!-- Siguiente -->
        Proceder al pago
      </button>
    </div>

    <spinner-ttt :show="loading"></spinner-ttt>


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
// import apiTools from "@/app/shared/utils/apiTools"
import { CALENDAR_LANG } from "@/config";

import { createDelivery, getProductStore, setProductStore } from "@/app/shared/global/services/product-service";

import { fetchOneParking } from "@/app/shared/global/services/parking-service";
// detalle del plan seleccionado

export default {
  name: "ContractResumen",
  components: {

  },
  data() {
    return {
      step: 5,
      elemento: "Resumen del Plan",
      loading: true,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        hours:[],
      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      errorPlan: false,

      parkings: [],
      planes: [],
      parking: null,

    };
  },
  created() {


    // this.getParking();
  },
  async mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      await this.setDataLocalStorage();
    }

    this.getParking();

  },

  computed: {

    productItem: function () {
      return {...this.item}
    },
  },

  methods: {

    async getParking() {

      try {

        const resp = await fetchOneParking(this.product.parkings_id);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(`Error al obtener el parkings`, null, 'error', '2000');
          return;
        }

        this.parking = resp.data;

      } catch (err) {
        this.$refs.toast.showToast(`Error al obtener el parking`, null, 'error', '2000');

      } finally {
        this.loading = false;
      }
    },

    saveDelivery() {

      // this.$validator.validateAll('new-delivery').then( async (valid) => {

      //   if (valid ) {

          this.loading = true;
          const errorMessage = `Se ha producido un error`;

          try {

            // const contractToSave = {
            //  ...this.product
            // }
            // this.contractPlanApi = {...contractToSave};

            this.nextStep();

          } catch (e) {
            console.log(e);
            this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');

          } finally {
            this.loading = false;
          }

      //   } else {
      //     this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
      //   }
      // })

    },

    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        if (storedData) {

          this.product = {
            ...storedData,
          };

        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    saveDataLocalStorage() {
      setProductStore(this.product);
    },


    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      // const data = { valid: true, parkingId: this.product.parkings_id, plandId:  this.product.plans_id  }
      this.$emit("validForm", data);
      this.loading = false;



    },



    formatDataSelect(ad) {

      if (ad) {
        const label = ad.store ? `${ad.alias} - ${ad.address}` : ad.address

        return {
          label: label, //`${ad.alias} - ${ad.address}`,
          value: ad.id
        }
      }
    },






  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
